<template>
  <div class="gsl-hrm-oauth-container">
    <div class="gsl-hrm-card-container">
      <login-branding
        :img-src="loginBannerSrc"
        class="gsl-hrm-oauth-branding"
        style="max-width: 200px"
      />

      <oxd-divider />

      <oxd-form>
        <oxd-form-row>
          <oxd-grid>
            <oxd-grid-item>
              <oxd-input-field
                ref="codeField"
                :model-value="code"
                rows="10"
                type="textarea"
                readonly
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <div class="gsl-hrm-oauth-button-container">
          <oxd-button
            display-type="secondary"
            class="gsl-hrm-oauth-button"
            size="medium"
            :label="$t('general.copy')"
            @click="onCopy"
          />
        </div>
      </oxd-form>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import LoginBranding from '@/orangehrmAuthenticationPlugin/components/LoginBranding.vue';

export default {
  name: 'OAuthAuthorizationCode',
  components: {
    'login-branding': LoginBranding,
  },
  props: {
    code: {
      type: String,
      required: true,
    },
    loginBannerSrc: {
      type: String,
      required: true,
    },
  },
  methods: {
    onCopy() {
      // Fallback copy method (safe and works in most browsers)
      const textarea = document.createElement('textarea');
      textarea.value = this.code;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      this.$toast.success({
        title: this.$t('general.copied'),
        message: this.$t('general.code_copied_to_clipboard'),
      });
    },
  },
};
</script>

<style src="./oauth-authorize.scss" scoped lang="scss"></style>
